import { type PropsWithChildren, useEffect } from 'react';
import { matchRoutes, Outlet, useNavigate } from 'react-router-dom';
import { Layout } from 'antd';
import PosFloatMenu from 'pos-client/components/generic/float-menu/PosFloatMenu.tsx';
import { NavMenuContextProvider } from 'pos-client/contexts/NavMenuContext.tsx';
import { useIsMobile } from 'pos-client/hooks/useIsMobile.ts';

import { AppNavigation } from './AppNavigation.tsx';

const AppLayout = ({ children }: PropsWithChildren) => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  useEffect(() => {
    const redirectUrl = localStorage.getItem('requestUrl');
    if (redirectUrl && redirectUrl !== '/') {
      localStorage.removeItem('requestUrl');
      navigate(redirectUrl);
    }
  }, [navigate]);

  const isSiderVisible = !!matchRoutes(
    [
      { path: '/orders/manage-orders/:id/invoice', exact: true },
      {
        path: '/orders/manage-orders/:id/workflow-invoice/:jobId',
        exact: true,
      },
    ],
    window.location.pathname
  )?.length;

  return (
    <NavMenuContextProvider initialValue={isMobile}>
      <Layout
        hasSider={!isMobile && isSiderVisible}
        style={{
          minHeight: '100vh',
          flexDirection: 'row',
          width: '100%',
        }}
      >
        <AppNavigation isMobile={isMobile} />
        {children ? children : <Outlet />}
        <PosFloatMenu />
      </Layout>
    </NavMenuContextProvider>
  );
};

export default AppLayout;
